import { render, staticRenderFns } from "./Partners.vue?vue&type=template&id=779bd670&scoped=true&"
import script from "./Partners.js?vue&type=script&lang=js&"
export * from "./Partners.js?vue&type=script&lang=js&"
import style0 from "./Partners.scss?vue&type=style&index=0&id=779bd670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779bd670",
  null
  
)

export default component.exports